module.exports = __webpack_public_path__ + "img/ourQuality_img.6bcd2765.jpg";